import { ChevronDown } from 'lucide-react'
import { useState } from 'react'
import { useLanguage } from '../context/LanguageContext'

export default function LanguageSwitcher() {
  const [open, setOpen] = useState(false)
  const { language, languageOptions, setLanguage, t } = useLanguage()

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-ng-dark/20 text-sm font-medium text-ng-dark hover:bg-ng-dark/5 transition-colors"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span>{languageOptions.find((option) => option.code === language)?.label || 'Français'}</span>
        <ChevronDown className="w-4 h-4" />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 rounded-2xl border border-ng-dark/10 bg-white shadow-xl overflow-hidden z-50">
          <div className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-ng-dark/40 border-b border-ng-dark/5">
            {t('common.language')}
          </div>
          <div className="py-2 max-h-72 overflow-auto">
            {languageOptions.map((option) => (
              <button
                key={option.code}
                type="button"
                onClick={() => {
                  setLanguage(option.code)
                  setOpen(false)
                }}
                className={`w-full text-left px-4 py-2.5 text-sm transition-colors ${
                  option.code === language ? 'bg-ng-dark/5 text-ng-dark font-medium' : 'text-ng-dark/70 hover:bg-ng-dark/5'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}